export default {
  apiRoot: process.env.REACT_APP_APIROOT,
  claraRoot: process.env.REACT_APP_CLARAROOT || `https://clara.io`,
};



// WEBPACK FOOTER //
// ./src/config.js